import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    notificationListLoading: false,
    notificationListSuccess: null,
    notificationListError: '',
    getNotificationLoading: false,
    getNotificationSuccess: {},
    getNotificationError: '',
    createNotificationLoading: false,
    createNotificationSuccess: {},
    createNotificationError: '',
    termGoal: [],
    batches: [],
}

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setNotificationListLoading: (state, action) => {
            state.notificationListLoading = true;
            state.notificationListSuccess = null;
            state.notificationListError = '';
        },
        setNotificationListSuccess: (state, action) => {
            state.notificationListLoading = false;
            state.notificationListSuccess = action.payload;
            state.notificationListError = '';
        },
        setNotificationListError: (state, action) => {
            state.notificationListLoading = false;
            state.notificationListSuccess = null;
            state.notificationListError = action.payload;
        },
        setGetNotificationLoading: (state) => {
            state.getNotificationLoading = true;
            state.getNotificationSuccess = {};
            state.getNotificationError = '';
        },
        setGetNotificationSuccess: (state, action) => {
            state.getNotificationLoading = false;
            state.getNotificationSuccess = action.payload.data;
            state.getNotificationError = '';
        },
        setGetNotificationError: (state, action) => {
            state.getNotificationLoading = false;
            state.getNotificationSuccess = {};
            state.getNotificationError = action.payload;
        },
        setCreateNotificationLoading: (state) => {
            state.createNotificationLoading = true;
            state.createNotificationSuccess = {};
            state.createNotificationError = '';
        },
        setCreateNotificationSuccess: (state, action) => {
            state.createNotificationLoading = false;
            state.createNotificationSuccess = action.payload;
            state.createNotificationError = '';
        },
        setCreateNotificationError: (state, action) => {
            state.createNotificationLoading = false;
            state.createNotificationSuccess = {};
            state.createNotificationError = action.payload;
        },
        setBatches: (state, action) => {
            state.batches = action.payload
        },
        resetDetails: (state, action) => {
            state.getNotificationSuccess = {};
            state.createNotificationSuccess = {}
        },
    },
})

export const {
    setCreateNotificationLoading, setCreateNotificationSuccess,
    setCreateNotificationError, setNotificationListLoading,
    setNotificationListSuccess, setNotificationListError,
    setGetNotificationLoading, setGetNotificationSuccess,
    setGetNotificationError, setBatches,
    resetDetails
} = notificationSlice.actions

export default notificationSlice.reducer;